import { useRef, useEffect } from 'react';
import { turnMsToSeconds } from '../helpers/common';

/**
 * This hook tracks the time spent on each activity and runs
 * a call back after component unmounts
 *
 * @param {function} cb The callback function after timer has ended
 */
const useTimer = (cb) => {
  const timer = useRef(null);

  useEffect(() => {
    timer.current = { start: Date.now() };
    return () => {
      const end = Date.now();
      timer.current = {
        ...timer.current,
        duration: turnMsToSeconds(end - timer.current.start).complete,
        end
      };
      cb(timer.current);
    };
  }, []);

  return timer.current;
};

export {
  useTimer,
  useTimer as default
};
